import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'containers/Leads/actions';
import Select from 'components/FormFields/Select';
import APModal from 'components/Modal/APModal';

import './styles.scss';

const ArchiveModal = ({ leadId, lostReasons, lostStatus, active, archiveOpened, setArchiveOpened, onArchive }) => {
  const dispatch = useDispatch();
  const { updateLeadStatus } = bindActionCreators(actions, dispatch);
  const [reason, setReason] = useState(null);

  const dismissArchive = () => {
    setArchiveOpened(false);
  };

  const updateReason = (e) => {
    e.persist();
    setReason(e.target.value);
  };

  const archiveLead = () => {
    updateLeadStatus({
      errorPolicy: 'all',
      variables: {
        id: parseInt(leadId, 10),
        input: {
          status: 'Lost',
          leadCustomStatusId: parseInt(lostStatus.id, 10),
          reasonForNotBookingId: parseInt(reason, 10),
        },
      },
      current: active,
    });

    if (typeof onArchive === 'function') {
      onArchive();
    }

    dismissArchive();
  };

  useEffect(() => {
    if (!archiveOpened) setReason(null);
  }, [archiveOpened]);

  const ArchiveActions = (
    <button
      className="button"
      onClick={archiveLead}
      disabled={!reason && reason !== 0}
    >
      Mark as lost
    </button>
  );

  if (!lostReasons) return null;

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <APModal
        open={archiveOpened}
        onClose={() => setArchiveOpened(false)}
        name="leads-archive"
        title="Why didn't the lead book?"
        subtitle="To help clear the clutter, once you mark this lead as lost,
                  we’ll remove any lead related tasks from your calendar,
                  as well as the “All My Tasks” tab in your notification center."
        actions={ArchiveActions}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="form-group">
          <Select
            onChange={updateReason}
            value={reason}
          >
            <option
              value={0}
              disabled
              hidden
            >
              Select a reason
            </option>
            {lostReasons.map((reasonOption, key) => {
              return (
                <option
                  key={key}
                  value={reasonOption.id}
                >
                  {reasonOption.name}
                </option>
              );
            })}
          </Select>
        </div>
      </APModal>
    </div>
  );
};

export default ArchiveModal;
